// Translation: Turkish > Generic
const generic = Object.freeze({
	accountSettings: 'Hesap ayarları',
	active: 'Aktif',
	all: 'Tümü',
	apiCall: 'API isteği',
	apiCall_one: 'API isteği',
	apiCall_other: 'API istekleri',
	apiCalls: 'API istekleri',
	apiCallWithCount: '{{count}} API isteği',
	bestWithCount: 'En iyi {{count}}',
	billing: 'Faturalandırma',
	billingItemTypeItems: {
		ASSET_HOSTING: 'Nesne barındırma',
		ASSET_HOSTING_REFUND: 'Nesne barındırma iadesi',
		ASSET_REFUND: 'Nesne iadesi',
		ASSET_TRAINING_REFUND: 'Nesne eğitme iadesi',
		ASSET_USAGE: 'Nesne kullanımı',
		ASSET_USAGE_REFUND: 'Nesne kullanım iadesi',
		AUTO_TOP_UP: 'Otomatik kredi doldurma',
		BENCHMARK_OVERHEAD: 'Raporlama ve skorlama servic ücreti',
		EXPIRABLE_CREDIT: 'Süresi dolabilen kredi',
		OTHER: 'Servis ücreti',
		OVERHEAD: 'Servis ücreti',
		OVERHEAD_FINETUNE_TRAINING: 'FineTune servis ücreti',
		PAY_OUT: 'Giden ödeme',
		RESERVE_ASSET_USAGE: 'Rezerve nesne kullanımı',
		SERVICE_ASSET_USAGE: 'Servis nesne kullanımı',
		SUBSCRIPTION: 'Abonelik',
		SUPPLIER_FINETUNE_TRAINING: 'FineTune eğitmesi tedarikçi ücreti',
		TOP_UP: 'Kredi doldurma',
		TRANSFER: 'Transfer',
		TRIAL_TOP_UP: 'Deneme kredisi doldurma',
		UNKNOWN: 'Bilinmeyen işlem',
		UNSUBSCRIBE: 'Abonelikten çıkma'
	},
	billingTypeItems: {
		service: 'Servis',
		transfer: 'Transfer'
	},
	by: '{{reference}} tarafından',
	byWithItem: '{{item}} ({{reference}} tarafından)',
	chartTypeItems: {
		barChart: 'Çubuk grafik',
		boxPlotChart: 'Kutu grafiği'
	},
	collected: 'Toplandı',
	comingSoon: 'Yakında geliyor',
	comparisonTypeItems: {
		contains: 'Kapsar',
		different: 'Farklıdır',
		differentWithValue: '≠ {{value}}',
		equal: 'Eşittir',
		equalWithValue: '= {{value}}',
		greaterThan: 'Büyüktür',
		greaterThanOrEqual: 'Büyük veya eşittir',
		greaterThanOrEqualWithValue: '>= {{value}}',
		greaterThanWithValue: '> {{value}}',
		in: 'İçindedir',
		lessThan: 'Küçüktür',
		lessThanOrEqual: 'Küçük veya eşittir',
		lessThanOrEqualWithValue: '<= {{value}}',
		lessThanWithValue: '< {{value}}'
	},
	configuration: 'Konfigurasyon',
	creationDate: 'Oluşturulma tarihi',
	default: 'Varsayılan',
	description: 'Açıklama',
	duration: 'Süre',
	error: 'Hata',
	extensions: 'Uzantılar',
	false: 'Yanlış',
	free: 'Ücretsiz',
	generalSettings: 'Genel ayarlar',
	id: 'ID',
	integrations: 'Entegrasyonlar',
	lastUpdate: 'Son güncelleme',
	license: 'Lisans',
	link: 'Link',
	loading: 'Yükleniyor',
	membershipPlan: 'Üyelik planı',
	membershipPlans: 'Üyelik planları',
	modificationDate: 'Değiştirilme tarihi',
	name: 'İsim',
	new: 'Yeni',
	none: 'Hiçbiri',
	noResults: 'Sonuç yok',
	notSelected: 'Seçilmedi',
	off: 'Kapalı',
	on: 'Açık',
	optional: 'Opsiyonel',
	owner: 'Sahip',
	plainText: 'Düz yazı',
	preferences: 'Tercihler',
	preview: 'Önizleme',
	price: 'Ücret',
	profile: 'Profil',
	request: 'İstek',
	required: 'Gerekli',
	result: 'Sonuç',
	roleItems: {
		admin: 'Yönetici',
		member: 'Üye',
		owner: 'Sahip'
	},
	saved: 'Kaydedildı',
	settings: 'Ayarlar',
	sortingMethodItems: {
		dateNew: 'En yeni',
		dateOld: 'En eski',
		updateLast: 'Son güncellenen',
		popularity: 'Popülerlik',
		priceHigh: 'Yüksek fiyat',
		priceLow: 'Düşük fiyat'
	},
	status: 'Durum',
	step: '{{number}}. adım',
	tag: 'Etiket',
	tag_one: 'Etiket',
	tag_other: 'Etiketler',
	tags: 'Etiketler',
	tagWithCount: '{{count}} etiket',
	team: 'Takım',
	teamMembers: 'Üyeler',
	teamSettings: 'Takım ayarları',
	totalDuration: 'Toplam süre',
	true: 'Doğru',
	type: 'Çeşit',
	unavailable: 'Mevcut değil',
	unknown: 'Bilinmiyor',
	unnamed: 'İsimsiz',
	updatedAt: 'Güncelleme',
	volume: 'Hacim',
	worstWithCount: 'En kötü {{count}}'
})

// Export
export default generic
